"use strict";

var __values = this && this.__values || function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator,
      m = s && o[s],
      i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function next() {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sortPorts = exports.sortGroups = exports.groupPortsByObjectResource = exports.decodePorts = void 0;

var port_1 = require("./port");

var port_logical_sort_1 = require("./port_logical_sort");

var port_index_1 = require("./port_index");

var object_type_1 = require("./lwm2m/object_type");

function decodePorts(p) {
  var e_1, _a;

  var ports = [];

  try {
    for (var p_1 = __values(p), p_1_1 = p_1.next(); !p_1_1.done; p_1_1 = p_1.next()) {
      var port = p_1_1.value;
      ports.push(port_1.decodePort(port));
    }
  } catch (e_1_1) {
    e_1 = {
      error: e_1_1
    };
  } finally {
    try {
      if (p_1_1 && !p_1_1.done && (_a = p_1.return)) _a.call(p_1);
    } finally {
      if (e_1) throw e_1.error;
    }
  }

  return new Ports(ports);
}

exports.decodePorts = decodePorts;
; // TODO: This should behave like an array and not just an iterable. It currently supports Iteration but not random access

var Ports
/*implements Iterable<Port>*/
=
/** @class */
function () {
  function Ports(ports) {
    this._ports = ports;
    this.length = ports.length;
    this.i = 0;
    this.sorted = false;
  }

  Ports.prototype.push = function (port) {
    this._ports.push(port);

    this.length = this._ports.length;
    this.i = 0;
    this.sorted = false;
  };

  Ports.prototype.order = function (force) {
    if (force === void 0) {
      force = false;
    }

    if (!this.sorted || force) {
      if (this._ports.length > 0) {
        this._ports.sort(port_logical_sort_1.logicalOrder);

        this._ports.sort(function (a, b) {
          if (a.readingMethod !== "none" && b.readingMethod === "none") {
            return -1;
          }

          if (a.readingMethod === "none" && b.readingMethod !== "none") {
            return 1;
          }

          return 0;
        });
      }

      this.sorted = true;
    } else {
      console.log("Port sorting requested but they are already sorted");
    }
  };

  Ports.prototype.ports = function () {
    return this._ports;
  };

  Ports.prototype.actuators = function () {
    var ret = [];

    this._ports.map(function (p) {
      if (p.actuatable) {
        ret.push(p);
      }
    });

    return ret;
  }; // We take all instances of the same resource, quire like MeterPorts except we group by resource and not objectType


  Ports.prototype.grouped = function () {
    var e_2, _a;

    var groupLabel = function groupLabel(label) {
      var l = label.split(" L1")[0];

      if (l.split("Inlet ").length > 1) {
        l = l.split("Inlet ")[1];
      }

      return l;
    };

    var grouped = [];

    var findMatching = function findMatching(index) {
      var e_3, _a;

      try {
        for (var grouped_1 = __values(grouped), grouped_1_1 = grouped_1.next(); !grouped_1_1.done; grouped_1_1 = grouped_1.next()) {
          var g = grouped_1_1.value;

          if (g.objectType === index.objectType() && g.resource === index.resource) {
            return g;
          }
        }
      } catch (e_3_1) {
        e_3 = {
          error: e_3_1
        };
      } finally {
        try {
          if (grouped_1_1 && !grouped_1_1.done && (_a = grouped_1.return)) _a.call(grouped_1);
        } finally {
          if (e_3) throw e_3.error;
        }
      }
    };

    try {
      for (var _b = __values(this._ports), _c = _b.next(); !_c.done; _c = _b.next()) {
        var port = _c.value;
        var index = new port_index_1.PortIndex(port.index);
        var group = findMatching(index);

        if (group == null) {
          group = {
            id: port.id,
            index: "/" + index.objectType() + "/0/" + index.resource,
            objectType: index.objectType(),
            resource: index.resource,
            label: groupLabel(port.label),
            valueType: 'd',
            ports: new Ports([])
          };
          grouped.push(group);
        }

        if (port.value !== 'd' || group.ports.length === 0) {
          group.valueType = port.valueType;
        }

        group.ports.push(port);
      }
    } catch (e_2_1) {
      e_2 = {
        error: e_2_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_2) throw e_2.error;
      }
    }

    return grouped;
  };

  Ports.prototype.group = function () {
    var e_4, _a;

    var loggingPorts = [];
    var notLoggingPorts = [];
    var otherPorts = [];

    try {
      for (var _b = __values(this._ports), _c = _b.next(); !_c.done; _c = _b.next()) {
        var port = _c.value;
        var index = new port_index_1.PortIndex(port.index);

        if (index.objectType() === object_type_1.ObjectType.ElectricityThreePhase || index.objectType() === object_type_1.ObjectType.ElectricityPhase || index.objectType() === object_type_1.ObjectType.HeatingCooling || index.objectType() === object_type_1.ObjectType.ElectricVehicleChargingStation || index.objectType() === object_type_1.ObjectType.Gas || index.objectType() === object_type_1.ObjectType.Water || index.objectType() === object_type_1.ObjectType.HeatCostAllocator || index.objectType() === object_type_1.ObjectType.MbusOther || index.objectType() === object_type_1.ObjectType.ColdWater || index.objectType() === object_type_1.ObjectType.HotWater || index.objectType() === object_type_1.ObjectType.RoomSensor || index.objectType() === object_type_1.ObjectType.Fan || index.objectType() === object_type_1.ObjectType.HeatingCoolingLegacy || index.objectType() === object_type_1.ObjectType.HeatingCoolingTypo || index.objectType() === object_type_1.ObjectType.Pressure || index.objectType() === object_type_1.ObjectType.GasFior) {
          if (port.readingMethod === "none") {
            notLoggingPorts.push(port);
          } else {
            loggingPorts.push(port);
          }
        } else {
          otherPorts.push(port);
        }
      }
    } catch (e_4_1) {
      e_4 = {
        error: e_4_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_4) throw e_4.error;
      }
    }

    return {
      logging: loggingPorts,
      notLogging: notLoggingPorts,
      other: otherPorts
    };
  };

  Ports.prototype.meters = function () {
    var e_5, _a;

    var meters = [];

    var findMeterIndex = function findMeterIndex(index) {
      for (var i = 0; i < meters.length; i++) {
        if (meters[i].index === index) {
          return i;
        }
      }

      return -1;
    };

    if (!this.sorted) {
      this.order();
    }

    var other = {
      "index": "other",
      "objectType": object_type_1.ObjectType.Unknown,
      "instance": "",
      "name": "Other",
      "location": "",
      "ports": new Ports([])
    };

    try {
      for (var _b = __values(this._ports), _c = _b.next(); !_c.done; _c = _b.next()) {
        var port = _c.value;
        var index = new port_index_1.PortIndex(port.index);

        if (index.objectType() === object_type_1.ObjectType.ElectricityThreePhase || index.objectType() === object_type_1.ObjectType.ElectricityPhase || index.objectType() === object_type_1.ObjectType.HeatingCooling || index.objectType() === object_type_1.ObjectType.ElectricVehicleChargingStation || index.objectType() === object_type_1.ObjectType.Gas || index.objectType() === object_type_1.ObjectType.Water || index.objectType() === object_type_1.ObjectType.HeatCostAllocator || index.objectType() === object_type_1.ObjectType.MbusOther || index.objectType() === object_type_1.ObjectType.ColdWater || index.objectType() === object_type_1.ObjectType.HotWater || index.objectType() === object_type_1.ObjectType.RoomSensor || index.objectType() === object_type_1.ObjectType.Fan || index.objectType() === object_type_1.ObjectType.HeatingCoolingLegacy || index.objectType() === object_type_1.ObjectType.HeatingCoolingTypo || index.objectType() === object_type_1.ObjectType.Pressure || index.objectType() === object_type_1.ObjectType.GasFior) {
          var meterI = findMeterIndex(index.meterIndex());

          if (meterI === -1) {
            var parentIndex = new port_index_1.PortIndex(index.meterIndex());
            meters.push({
              "index": index.meterIndex(),
              "objectType": parentIndex.objectType(),
              "instance": parentIndex.objectInstance,
              "name": this.meterIndexToName(index.meterIndex()),
              "location": this.meterIndexToLocation(index.meterIndex()),
              "ports": new Ports([])
            });
            meterI = findMeterIndex(index.meterIndex());
          }

          meters[meterI]["ports"].push(port);
        } else {
          other.ports.push(port);
        }
      }
    } catch (e_5_1) {
      e_5 = {
        error: e_5_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_5) throw e_5.error;
      }
    }

    if (other.ports.length > 0) {
      meters.push(other);
    }

    for (var m in meters) {
      meters[m].ports.order();
    }

    return meters;
  };

  Ports.prototype.findByID = function (id) {
    var e_6, _a;

    try {
      for (var _b = __values(this._ports), _c = _b.next(); !_c.done; _c = _b.next()) {
        var port = _c.value;

        if (port.id === id) {
          return port;
        }
      }
    } catch (e_6_1) {
      e_6 = {
        error: e_6_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_6) throw e_6.error;
      }
    }

    return null;
  };

  Ports.prototype.findByIndex = function (index) {
    var e_7, _a;

    try {
      for (var _b = __values(this._ports), _c = _b.next(); !_c.done; _c = _b.next()) {
        var port = _c.value;

        if (port.index === index) {
          return port;
        }
      }
    } catch (e_7_1) {
      e_7 = {
        error: e_7_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_7) throw e_7.error;
      }
    }

    return null;
  };

  Ports.prototype.filterByIndices = function (indices) {
    var e_8, _a, e_9, _b;

    var ret = [];

    try {
      for (var _c = __values(this._ports), _d = _c.next(); !_d.done; _d = _c.next()) {
        var port = _d.value;

        try {
          for (var indices_1 = (e_9 = void 0, __values(indices)), indices_1_1 = indices_1.next(); !indices_1_1.done; indices_1_1 = indices_1.next()) {
            var index = indices_1_1.value;

            if (port.index.substr(0, index.length) === index) {
              ret.push(port);
            }
          }
        } catch (e_9_1) {
          e_9 = {
            error: e_9_1
          };
        } finally {
          try {
            if (indices_1_1 && !indices_1_1.done && (_b = indices_1.return)) _b.call(indices_1);
          } finally {
            if (e_9) throw e_9.error;
          }
        }
      }
    } catch (e_8_1) {
      e_8 = {
        error: e_8_1
      };
    } finally {
      try {
        if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
      } finally {
        if (e_8) throw e_8.error;
      }
    }

    return ret;
  };

  Ports.prototype.filterByRegExp = function (selector) {
    var e_10, _a;

    var ret = [];

    try {
      for (var _b = __values(this._ports), _c = _b.next(); !_c.done; _c = _b.next()) {
        var port = _c.value;

        if (port.index.search(selector) !== -1) {
          ret.push(port);
        }
      }
    } catch (e_10_1) {
      e_10 = {
        error: e_10_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_10) throw e_10.error;
      }
    }

    return ret;
  }; // newerThan(time:time);

  /* direct port from corona-web, perhaps a more general function would be better */


  Ports.prototype.fieldByObjectResource = function (object, resource) {
    var e_11, _a;

    try {
      for (var _b = __values(this._ports), _c = _b.next(); !_c.done; _c = _b.next()) {
        var port = _c.value;
        var indexparts = port.index.split("/");

        if (indexparts[1] === object && indexparts[3] == resource) {
          return port;
        }
      }
    } catch (e_11_1) {
      e_11 = {
        error: e_11_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_11) throw e_11.error;
      }
    }

    return null;
  };

  ;

  Ports.prototype.calculateOldSLA = function () {
    var e_12, _a;

    var sla = {
      "data_yesterday": 0.00,
      "data_today": 0.00,
      "parameters": {
        'entries_yesterday': 0,
        'expected_yesteday': 0,
        'entries_today': 0,
        'expected_today': 0
      }
    };
    var dataSlaYesterdaySum = 0;
    var dataSlaTodaySum = 0;
    var expectedYesterdaySum = 0.00;
    var expectedTodaySum = 0.00;
    var hasLogged = false;
    var ignoredPorts = ['/3/', '/4/', '/3306/', '/3347/', '/7050/', '/7051/', '/ds', '/dev/', '/sys/', '/sen/', '/obis/', '/3303/0/5700'];

    var isIgnored = function isIgnored(portIndex) {
      for (var i = ignoredPorts.length - 1; i >= 0; i--) {
        if (portIndex.substr(0, ignoredPorts[i].length) === ignoredPorts[i]) {
          return true;
        }
      } // This catches stray prefixed ports with prefix (the prefix is exactly 16 chars long and the URI starts with /)


      if (portIndex.length > 18) {
        return portIndex[17] === "/";
      }

      return false;
    };

    var onlyIgnoredPorts = true;

    try {
      for (var _b = __values(this._ports), _c = _b.next(); !_c.done; _c = _b.next()) {
        var port = _c.value; // NOTE: This shouldn't be here but we are sneaking it in (remove when solved device side or backend side)

        if (port.index == "/3303/0/5700") {
          // we limit the measured figures on Zodiac temp to a max of one
          port.measuredFigures = Math.min(port.measuredFigures, 1);
          port.label = "Internal temperature";
        } else if (port.index == "/3305/0/5800") {
          // we limit the measured figures on Active Net power derived to a max of 2
          port.measuredFigures = Math.min(port.measuredFigures, 2);
        }

        if (!isIgnored(port.index)) {
          onlyIgnoredPorts = false;
          port.calculateOldSLA();

          if (port.expectedYesterday > 0) {
            dataSlaYesterdaySum = dataSlaYesterdaySum + Math.min(port.entriesYesterday, port.expectedYesterday);
            dataSlaTodaySum = dataSlaTodaySum + port.entriesToday;
            expectedYesterdaySum = expectedYesterdaySum + port.expectedYesterday;
            expectedTodaySum = expectedTodaySum + port.expectedToday;
            hasLogged = true;
          } else {
            // there are two cases here, maxPeriod==0 or minPeriod > one day
            // for maxPeriod==0 we do not calculate SLA
            // if maxPeriod > one day we add those entries to the SLA as a "bonus"
            if (port.entriesYesterday > 0) {
              dataSlaYesterdaySum = dataSlaYesterdaySum + port.entriesYesterday;
              expectedYesterdaySum = expectedYesterdaySum + port.entriesYesterday;
              hasLogged = true;
            }

            if (port.entriesToday > 0) {
              dataSlaTodaySum = dataSlaTodaySum + port.entriesToday;
              expectedTodaySum = expectedTodaySum + port.entriesToday;
              ;
              hasLogged = true;
            }
          }
        } else {
          port.sla = {
            "yesterday": 100.00,
            "today": 100.00
          };
        }
      }
    } catch (e_12_1) {
      e_12 = {
        error: e_12_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_12) throw e_12.error;
      }
    } // do something with the sums?


    if (hasLogged) {
      if (expectedYesterdaySum > 0) {
        var data_yesterday = dataSlaYesterdaySum / expectedYesterdaySum * 100;
        sla.data_yesterday = data_yesterday > 100 ? 100.00 : data_yesterday;
      } else {
        sla.data_yesterday = 0;
      }

      if (expectedTodaySum > 0) {
        var data_today = dataSlaTodaySum / expectedTodaySum * 100;
        sla.data_today = data_today > 100 ? 100.00 : data_today;
      } else {
        sla.data_today = dataSlaTodaySum > 0 ? 100.0 : 0.0;
      }

      sla.parameters = {
        'entries_yesterday': dataSlaYesterdaySum,
        'expected_yesteday': expectedYesterdaySum,
        'entries_today': dataSlaTodaySum,
        'expected_today': expectedTodaySum
      };
    }

    if (onlyIgnoredPorts && this._ports.length > 0) {
      return {
        "data_yesterday": 100.00,
        "data_today": 100.00,
        "parameters": {
          'entries_yesterday': 0,
          'expected_yesteday': 0,
          'entries_today': 0,
          'expected_today': 0
        }
      };
    }

    return sla;
  };
  /* Array forwarding functions */
  //[Symbol.iterator]() { return this._ports[Symbol.iterator](); } // DOES NOT WORK WITH IE11

  /* PRIVATE FUNCTIONS */


  Ports.prototype.meterIndexToName = function (index) {
    // Köklot gemini stuffs
    if (index === "/10242/1") {
      return "Main meter total";
    }

    if (index === "/10242/2") {
      return "Värme - A-Collection EM340";
    }

    if (index === "/10242/3") {
      return "Ventilation - Carlo Gavazzi EM111";
    }

    if (index === "/10242/10") {
      return "Varmvattenberedare - A-Collection EM340";
    }

    if (index === "/10242/11") {
      return "EVSE - A-Collection EM340";
    }

    if (index === "/10242/12") {
      return "Solpaneler - A-Collection EM340";
    }

    if (index === "/10242/20") {
      return "Värme, garage - Carlo Gavazzi EM111";
    }

    if (index === "/10242/21") {
      return "Luftvärmepump, garage - Carlo Gavazzi EM111";
    }

    if (index === "/10261/9") {
      return "Vattenflöde";
    }

    if (index === "/10265/5") {
      return "Innetemperatur, Våning 1";
    }

    if (index === "/10265/7") {
      return "Innetemperatur, Tekniska utrymmet";
    }

    if (index === "/10265/8") {
      return "Utetemperatur";
    } // Dag KRS


    if (index === "/10257/0") {
      return "Värmeenergi";
    }

    if (index === "/10257/1") {
      return "Värmeenergi, uppvärmning";
    }

    if (index === "/10257/2") {
      return "Värmeenergi, bruksvatten";
    }

    if (index === "/10257/3") {
      return "Värmeenergi, bruksvatten";
    }

    if (index === "/10265/1") {
      return "Temperatur";
    }

    if (index === "/10265/2") {
      return "Temperatur";
    }

    if (index === "/10265/3") {
      return "Termostat";
    } // Zehnder stuff


    if (index.substr(0, 7) == "/10270/") {
      return "Zehnder drive " + index[index.length - 1];
    }

    var i = new port_index_1.PortIndex(index);

    if (i.objectType() === object_type_1.ObjectType.ElectricityThreePhase || i.objectType() === object_type_1.ObjectType.ElectricityPhase) {
      return "Electricity Meter";
    }

    if (i.objectType() === object_type_1.ObjectType.HeatCostAllocator || i.objectType() === object_type_1.ObjectType.HeatingCooling || i.objectType() === object_type_1.ObjectType.HeatingCoolingLegacy) {
      return "Heating/Cooling Meter";
    }

    if (i.objectType() === object_type_1.ObjectType.Water) {
      return "Water Meter";
    }

    if (i.objectType() === object_type_1.ObjectType.MbusOther) {
      return "Temperature";
    } // NOTE: this will shoot us in the foot one day...one day


    if (i.objectType() === object_type_1.ObjectType.Pressure) {
      return "Pressure";
    }

    return index;
  };

  Ports.prototype.meterIndexToLocation = function (index) {
    // Köklot gemini stuffs
    if (index === "/10242/1") {
      return "";
    }

    if (index === "/10242/2") {
      return "Gruppcentral 1";
    }

    if (index === "/10242/3") {
      return "Gruppcentral 1";
    }

    if (index === "/10242/10") {
      return "";
    }

    if (index === "/10242/11") {
      return "Garage";
    }

    if (index === "/10242/12") {
      return "Garage";
    }

    if (index === "/10242/20") {
      return "Garage";
    }

    if (index === "/10242/21") {
      return "Garage";
    } // Havets hus


    if (index === "/10242/22") {
      return "Ventilation";
    }

    if (index === "/10242/22") {
      return "Mångfunktionsrum";
    }

    if (index === "/10242/24") {
      return "Fastighet, Gruppcentral 1";
    }

    if (index === "/10242/26") {
      return "VVS";
    }

    if (index === "/10242/27") {
      return "Fastighet, Huvudcentral";
    }

    if (index === "/10242/29") {
      return "Värme";
    }

    if (index === "/10261/9") {
      return "";
    }

    if (index === "/10265/5") {
      return "Våning 1";
    }

    if (index === "/10265/7") {
      return "Tekniska utrymmet";
    }

    if (index === "/10265/8") {
      return "Ute";
    } // Dag KRS


    if (index === "/10257/0") {
      return "";
    }

    if (index === "/10257/1") {
      return "";
    }

    if (index === "/10257/2") {
      return "";
    }

    if (index === "/10257/3") {
      return "";
    }

    if (index === "/10265/1") {
      return "Ute";
    }

    if (index === "/10265/2") {
      return "Köket";
    }

    if (index === "/10265/3") {
      return "Köket";
    } // Zehnder stuff


    if (index.substr(0, 7) == "/10270/") {
      return "";
    }

    return "";
  };

  return Ports;
}();

exports.default = Ports;

function groupPortsByObjectResource(ports) {
  var e_13, _a;

  var groupLabel = function groupLabel(label) {
    var l = label.split(" L1")[0];

    if (l.split("Inlet ").length > 1) {
      l = l.split("Inlet ")[1];
    }

    return l;
  };

  var grouped = [];

  var findMatching = function findMatching(index) {
    var e_14, _a;

    try {
      for (var grouped_2 = __values(grouped), grouped_2_1 = grouped_2.next(); !grouped_2_1.done; grouped_2_1 = grouped_2.next()) {
        var g = grouped_2_1.value;

        if (g.objectType === index.objectType() && g.resource === index.resource) {
          return g;
        }
      }
    } catch (e_14_1) {
      e_14 = {
        error: e_14_1
      };
    } finally {
      try {
        if (grouped_2_1 && !grouped_2_1.done && (_a = grouped_2.return)) _a.call(grouped_2);
      } finally {
        if (e_14) throw e_14.error;
      }
    }
  };

  try {
    for (var _b = __values(sortPorts(ports)), _c = _b.next(); !_c.done; _c = _b.next()) {
      var port = _c.value;
      var index = new port_index_1.PortIndex(port.index);
      var group = findMatching(index);

      if (group == null) {
        group = {
          id: port.id,
          index: "/" + index.objectType() + "/0/" + index.resource,
          objectType: index.objectType(),
          resource: index.resource,
          label: groupLabel(port.label),
          valueType: 'd',
          ports: new Ports([])
        };
        grouped.push(group);
      }

      if (port.value !== 'd' || group.ports.length === 0) {
        group.valueType = port.valueType;
      }

      group.ports.push(port);
    }
  } catch (e_13_1) {
    e_13 = {
      error: e_13_1
    };
  } finally {
    try {
      if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
    } finally {
      if (e_13) throw e_13.error;
    }
  }

  return sortGroups(grouped);
}

exports.groupPortsByObjectResource = groupPortsByObjectResource;

function sortGroups(ports) {
  var sorted = ports;
  sorted.sort(port_logical_sort_1.logicalOrder);
  return sorted;
}

exports.sortGroups = sortGroups;

function sortPorts(ports) {
  var sorted = ports;
  sorted.sort(port_logical_sort_1.logicalOrder);
  sorted.sort(function (a, b) {
    if (a.readingMethod !== "none" && b.readingMethod === "none") {
      return -1;
    }

    if (a.readingMethod === "none" && b.readingMethod !== "none") {
      return 1;
    }

    return 0;
  });
  return sorted;
}

exports.sortPorts = sortPorts;